
const formname = "register"
const login = "כבר רשומים? התחברו"
const userLogin = "לחזרה למערכת האבחונים"

export { formname, login, userLogin }